import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable, tap } from 'rxjs';
import { Role, RoleAccessService } from './role-access.service';
import { MapMyIndiaService } from '../../service/mapmyindia.service';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private readonly TOKEN_KEY = 'jwt';
  private readonly ROLE_KEY = 'userRole';

  constructor(
    private http: HttpClient,
    private mapMyIndiaService: MapMyIndiaService,
    private roleAccessService: RoleAccessService
  ) {}

  login(userName: string, password: string): Observable<any> {
    const url = `${environment.baseUrl}/tms-onboarding/user/signIn`;
    return this.http.post<any>(url, {
      userName,
      password
    }, {
      headers: {
        'accept': '*/*',
        'version': '1.0',
        'Content-Type': 'application/json'
      }
    }).pipe(
      tap(response => {
        if (response.statusCode === 200 && response.data && response.data.length > 0) {
          const userData = response.data[0];
          this.handleLoginSuccess(userData);
        }
      })
    );
  }

  private handleLoginSuccess(userData: any) {
    console.log('userData', userData);
    // Store token
    if (userData.token) {
      this.setToken(userData.token);
    }

    // Store user role
    if (userData.role) {
      this.setUserRole(userData.role as Role);
    }


    // Set user access permissions
    if (userData.allowedModules && Array.isArray(userData.allowedModules)) {
      this.roleAccessService.setUserAccess(userData.role as Role, userData.allowedModules, userData.allowedTransits);
    }
  }

  setToken(token: string) {
    console.log(">>>>>>>>>",token);
    localStorage.setItem(this.TOKEN_KEY, token);
  }

  getToken(): string | null {
    return localStorage.getItem(this.TOKEN_KEY);
  }

  setUserRole(role: Role) {
    localStorage.setItem(this.ROLE_KEY, role);
  }

  getUserRole(): Role | null {
    return localStorage.getItem(this.ROLE_KEY) as Role | null;
  }

  clearToken() {
    localStorage.removeItem(this.TOKEN_KEY);
    localStorage.removeItem(this.ROLE_KEY);
    // Clear role access service data
    this.roleAccessService.clearUserAccess();
    // Also clear MapMyIndia token on logout
    this.mapMyIndiaService.clearToken();
  }

  isLoggedIn(): boolean {
    return !!this.getToken();
  }

  decodeToken(): any {
    const token = this.getToken();
    if (!token) return null;
    try {
      const payload = token.split('.')[1];
      const decoded = atob(payload.replace(/-/g, '+').replace(/_/g, '/'));
      return JSON.parse(decodeURIComponent(escape(decoded)));
    } catch (e) {
      return null;
    }
  }

  isTokenExpired(token: string): boolean {
    if (!token) return true;
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      // exp is in seconds, Date.now() in ms
      return payload.exp * 1000 < Date.now();
    } catch (e) {
      return true; // treat as expired if invalid
    }
  }
}

export function isTokenExpired(token: string): boolean {
  if (!token) return true;
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    // exp is in seconds, Date.now() in ms
    return payload.exp * 1000 < Date.now();
  } catch (e) {
    return true; // treat as expired if invalid
  }
}
